import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { Notification } from "@components/Notification/Notification";
import { useAddBillModal } from "@hooks/useAddBillModal";
import { useBannerMessagesQuery } from "@services/messages/queries";

export const EduInstitutionNotification = () => {
  const { t } = useTranslation();
  const { data: bannerMessages } = useBannerMessagesQuery();

  const { openAddBillModal } = useAddBillModal();

  const exists = bannerMessages?.some(
    (banner) => banner.bannerType === "newEducationInstitutions",
  );

  if (!exists) {
    return null;
  }

  return (
    <Notification
      title={t("eduInstitutionNotification.title")}
      description={t("eduInstitutionNotification.description")}
      imagePath="/images/notification/education-icon.png"
      variant="big"
      button={
        <Button
          onClick={() => openAddBillModal()}
          aria-label={t("eduInstitutionNotification.add")}
        >
          {t("eduInstitutionNotification.add")}
        </Button>
      }
    />
  );
};
